import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthStore } from './auth.store';

/**
 * Guarda rotas autenticadas (`/app/**`). Se não autenticado, redireciona
 * pra `/auth/login` mantendo o `returnUrl` na queryParam.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const store = inject(AuthStore);
  const router = inject(Router);

  if (store.isAuthenticated()) return true;

  return router.createUrlTree(['/auth/login'], {
    queryParams: { returnUrl: state.url },
  });
};

/**
 * Guarda rotas de auth (`/auth/login`, `/auth/registro`). Se já autenticado,
 * redireciona pra `/app` — evita o usuário ver a tela de login depois de
 * já estar logado.
 *
 * Exceção: `/auth/callback` deve sempre ativar pra que a página possa
 * processar o sessionToken da query e fazer `replaceUrl` limpando o token.
 */
export const notAuthGuard: CanActivateFn = (_route, state) => {
  const store = inject(AuthStore);
  const router = inject(Router);

  if (state.url.startsWith('/auth/callback')) return true;

  if (!store.isAuthenticated()) return true;

  return router.createUrlTree(['/app']);
};

/**
 * Guarda rotas que exigem ToS aceito (`/app/**` exceto `/onboarding`).
 * Se logado mas sem ToS, redireciona pra `/onboarding`.
 */
export const tosGuard: CanActivateFn = () => {
  const store = inject(AuthStore);
  const router = inject(Router);

  if (!store.isAuthenticated()) {
    return router.createUrlTree(['/auth/login']);
  }
  if (store.hasAcceptedTos()) return true;

  return router.createUrlTree(['/onboarding']);
};

/**
 * Guarda rotas /app/admin/**. Exige `currentUser.admin === true`. Se logado
 * sem flag admin, redireciona pra /app — não tem mensagem porque tela
 * "Acesso negado" é fricção desnecessária pra usuário comum.
 */
export const adminGuard: CanActivateFn = () => {
  const store = inject(AuthStore);
  const router = inject(Router);

  if (!store.isAuthenticated()) {
    return router.createUrlTree(['/auth/login']);
  }
  if (store.currentUser()?.admin) return true;
  return router.createUrlTree(['/app']);
};
